import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { Promotion } from "@/types/sms";

interface PromotionSelectProps {
  promotions: Promotion[];
  value: string | null;
  onChange: (id: string) => void;
  placeholder?: string;
}

/** Active-promotion picker reused by the campaign/keyword/invite wizards. */
export function PromotionSelect({ promotions, value, onChange, placeholder = "Select a promotion" }: PromotionSelectProps) {
  return (
    <Select value={value ?? undefined} onValueChange={onChange}>
      <SelectTrigger className="h-11">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {promotions.map((p) => (
          <SelectItem key={p.id} value={p.id}>
            {p.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
